import {useParams} from "react-router-dom";
import {ResidenceService} from "../../../service/residence/ResidenceService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {
    RaikoBaseCardContainer,
    RaikoBaseContainer, RaikoCustomSelect, raikoCustomSelectItemGenerator,
    RaikoSectionContainer,
    showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import RaikoLeafletMap from "../../../raikoComponents/raikoLeafletMap/RaikoLeafletMap";
import {RaikoLeafletIranProvinces} from "../../../raikoComponents/raikoLeafletMap/RaikoLeafletIranProvinces";
import {css} from "@emotion/css";

export default function ResidenceDetailMap() {

    let page = 0;
    const size = 20;

    const {id: residenceId} = useParams()

    const service = new ResidenceService();
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [positionChoice, setPositionChoice] = useState(0);
    const [centerLocation, setCenterLocation] = useState(RaikoLeafletIranProvinces.Kerman)


    const provinceChoice = [
        {
            id: 0,
            provinceName: "کرمان",
            centerLocation: RaikoLeafletIranProvinces.Kerman
        },
        {
            id: 1,
            provinceName: "مشهد",
            centerLocation: RaikoLeafletIranProvinces.RazaviKhorasan
        },
        {
            id: 2,
            provinceName: "تهران",
            centerLocation: RaikoLeafletIranProvinces.Tehran
        },

    ];


    useEffect(() => {
        getDataFromServer()
    }, []);

    function getDataFromServer() {
        loading.show()
        service.getResidenceGeoInfo(residenceId)
            .then((response) => {
                if (response.latitude) {
                    setLatitude(response.latitude)
                    setLongitude(response.longitude)

                    setCenterLocation(
                        {
                            name: "selected",
                            lat: response.latitude,
                            lng: response.longitude,
                            zoom: 17,
                            point: [response.latitude, response.longitude]
                        }
                    )

                }
            }).catch((err) => {
            showServerErrorMessage(err)
        }).finally(() => {
            loading.hide()
        })
    }


    function handleUpdateInfo() {
        if (latitude && longitude) {
            loading.show()
            service.updateResidenceGeoInfo(residenceId, latitude, longitude)
                .then((response) => {
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد")
                }).catch((err) => {
                showServerErrorMessage(err)
            }).finally(() => {
                loading.hide()
            })
        } else
            showServerErrorMessage("لطفا ابتدا موقعیت مکانی مورد نظر را انتخاب نمایید.");
    }

    return (
        <RaikoBaseContainer>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"موقعیت مکانی"}
                    hasActionButton
                    actionButtonOnclick={handleUpdateInfo}
                >
                    <div>
                        <RaikoCustomSelect
                            labelText={"پیمایش سریع"}
                            items={[
                                raikoCustomSelectItemGenerator(0, "کرمان"),
                                raikoCustomSelectItemGenerator(1, "مشهد"),
                                raikoCustomSelectItemGenerator(2, "تهران"),
                            ]}
                            value={positionChoice}
                            setValue={setPositionChoice}
                            onChange={e => {
                                provinceChoice.map((item) => {
                                    console.log("is", item.id)
                                    if (item.id === parseInt(e.target.value.toString())) {
                                        setCenterLocation(item.centerLocation)
                                    }
                                })
                                console.log("event is:", e)
                            }}
                        />
                    </div>

                    <RaikoLeafletMap
                        centerLocation={centerLocation}
                        latPoint={latitude}
                        lngPoint={longitude}
                        setLatPoint={setLatitude}
                        setLngPoint={setLongitude}
                    />

                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
        </RaikoBaseContainer>
    )
}
